<template>
  <div class="mobile">
    <div class="advantages">
      <h3>Deine Vorteile mit dem Express-Verkauf</h3>
      <ul>
        <li>
          <h5><i class="fa fa-check"></i> Einfach</h5>
          <p>
            Du musst keine Termine mit mehreren Interessenten abstimmen. Und die Abmeldung wird gleich für Dich erledigt – <b>kostenlos</b>.
          </p>
        </li>
        <li>
          <h5> <i class="fa fa-check"></i> Schnell</h5>
          <p>
            Ein Termin in Deiner Nähe ist schon am nächsten Tag möglich. Nimmst Du das Angebot an, wird die <b>Zahlung sofort</b> angewiesen.
          </p>
        </li>
        <li>
          <h5><i class="fa fa-check"></i> Sicher</h5>
          <p>
            Du verkaufst Dein Auto an von mobile.de <b>geprüfte Ankaufstationen</b> und erhältst bei jedem Termin ein transparentes Ankaufangebot.
          </p>
        </li>
      </ul>
    </div>
    <div class="locations">
      <div>
        <div class="map">
          <img src="~@/assets/mobile-karte.svg" alt="mobile.de karte" />
        </div>
        <div class="content">
          <h4>Immer In Deiner Nähe: Die neuen mobile.de Ankaufstationen</h4>
          <p>
            Deutschlandweit bietet mobile.de Dir den Express-Verkauf schon an<br />über <b>600 Ankaufstationen</b> an:
          </p>
          <ul>
            <li>Berlin</li>
            <li>München</li>
            <li>Hamburg</li>
            <li>Köln</li>
            <li>Nürnberg</li>
            <li>Düsseldorf</li>
            <li>Dortmund</li>
            <li>Frankfurt</li>
            <li>Stuttgart</li>
            <li>Wuppertal</li>
          </ul>
        </div>
      </div>
    </div>
    <div class="mobile-rating">
      <h4 class="title">Das sagen mehr als 10.000 Kunden</h4>
      <img src="~@/assets/rating.svg" alt="mobile.de karte" />
      <h4>4.5 / 5.0</h4>
    </div>
  </div>
</template>

<script>
export default {
  data: function() {
    return {
      store: window.Store,
    }
  }
}
</script>

<style lang="scss" scoped>
@import "~@/assets/vars";

$orange: #f60;

.mobile {
  &:after,
  &:before {
    clear: both;
    display: table;
    content: " ";
  }

  h3, h4, h5 {
    text-align: center;
    font-weight: bold;
    color: $dark-gray-variant;
  }

  h4 {
    font-size: 25px;
    line-height: 30px;
    margin-bottom: 18px;
    text-align: left;
  }

  p {
    font-size: 16px;
    color: $dark-gray-variant;
  }

  b {
    color: $black-variant !important;
    font-weight: bold;
  }

  .advantages,
  .mobile-rating,
  .locations > div {
    max-width: 1200px;
    margin: auto;
  }

  .advantages {
    padding: 54px 18px;

    .fa-check {
      display: inline-block;
      width: 24px;
      height: 24px;
      line-height: 24px;
      margin-right: 5px;
      color: white;
      font-size: 15px;
      vertical-align: bottom;
      border-radius: 50%;
      background-color: $green-variation;
    }

    h3 {
      font-size: 24px;
      margin-bottom: 36px;
      line-height: 30px;
    }

    h5 {
      font-size: 20px;
      margin-bottom: 18px;
    }

    ul {
      overflow: hidden;
      list-style-type: none;

      li {
        width: 33%;
        padding: 0 18px;
        float: left;
      }

      p {
        line-height: 22px;
      }
    }
  }

  .locations {
    background-color: $gray-light;
    overflow: hidden;
    padding: 54px 0;

    .map {
      float: left;
      padding: 0 85px 0 109px;
    }

    .content {
      overflow: hidden;
      padding: 81px 55px 0 0;
    }

    li {
      float: left;
      width: 33%;
      font-size: 16px;
      padding: 0;
      opacity: 0.9;
      text-align: left;
      color: $dark-gray-variant;
      margin-bottom: 6px;
    }

    p {
      opacity: 0.9;
      margin-bottom: 20px;
      text-align: left;
    }
  }

  .mobile-rating {
    padding: 54px 109px 0;
    text-align: center;

    & > * {
      display: inline-block;
    }

    h4 {
      margin-bottom: 0;
    }

    img {
      height: 25px;
      width: 150px;
      padding: 0 10px 0 12px;
    }
  }

  @media (max-width: 900px) {
    .mobile-rating {
      padding-top: 36px !important;
    }

    .mobile-rating h4:first-child {
      width: 100%;
      margin-bottom: 9px;
      text-align: center;
    }

    .map {
      padding-left: 35px !important;
      padding-right: 73px !important;

      img {
        width: 260px;
      }
    }

    .content {
      padding: 27px 35px 0 0 !important;
    }
  }

  @media (max-width: 720px) {
    .advantages {
      li {
        width: 100% !important;
        float: none !important;
      }

      li:not(:last-child) {
        margin-bottom: 27px;
      }
    }
  }

  @media (max-width: 700px) {
    .locations {
      padding: 36px 0 0 0;
    }

    .map, .content {
      float: none !important;
      padding: 0 18px 36px !important;

      h4, p {
        text-align: center;
      }

      ul {
        max-width: 500px;
        margin: auto;

        li {
          text-align: center;
        }
      }
    }

    .mobile-rating {
      padding: 36px 18px 0;

      .title {
        margin-bottom: 18px;
      }
    }
  }

  @media (max-width: 470px) {
    .advantages {
      padding: 36px 18px;
    }

    .content {
      h4 {
        font-size: 27px;
        text-align: left !important;
      }

      p {
        font-size: 18px;
        line-height: 24px;
        margin-bottom: 18px;
        text-align: left !important;
      }

      li {
        width: 45%;
        font-size: 18px;
        text-align: left !important;
      }
    }

    .mobile-rating {
      h4 {
        line-height: 32px;
        font-size: 32px;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/summary/SummaryMobile.vue